import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
// 积分商城
{
  path: "/pointsMall",
  name: "pointsMall",
  component: function component() {
    return import("../../../views/points-mall/index.vue");
  },
  meta: {
    title: "权益商城",
    foot: false
  }
},
// 积分商城商品搜索
{
  path: "/pointsMall/search/:id",
  name: "pointsMallSearch",
  component: function component() {
    return import("../../../views/points-mall/searchPointsGoods.vue");
  },
  meta: {
    title: "权益商城",
    foot: true
  }
},
// 积分商城专题活动
{
  path: "/pointsMall/activity/:id",
  name: "pointsMallActivity",
  component: function component() {
    return import("../../../views/points-mall/specialActivity.vue");
  },
  meta: {
    title: "专题活动",
    foot: true
  }
},
// 积分商城品牌
{
  path: "/pointsMall/brand/:id",
  name: "pointsMallBrand",
  component: function component() {
    return import("../../../views/points-mall/brand.vue");
  },
  meta: {
    title: "专题活动",
    foot: true
  }
},
// 积分商城商品详情
{
  path: "/pointsMall/goods/:id/:selectionId?",
  name: "pointsMallGoods",
  component: function component() {
    return import("../../../views/points-mall/pointsGoodsDetail.vue");
  },
  meta: {
    title: "商品详情",
    foot: true
  }
},
// 积分商城订单确认
{
  path: "/pointsMall/order/:goodsId/:poolId/:addressId/:total?",
  name: "pointsOrder",
  component: function component() {
    return import("../../../views/points-mall/pointsOrder.vue");
  },
  meta: {
    title: "确认订单",
    foot: true
  }
},
// 订单支付
{
  path: "/pointsOrderPay/:orderId/:orderNo/:payAmt?",
  name: "pointsOrderPay",
  component: function component() {
    return import("../../../views/points-mall/pointsOrderPay.vue");
  },
  meta: {
    title: "订单支付",
    foot: true
  }
},
// 积分商城商品支付成功
{
  path: "/pointsPaySuccess/:orderId/:orderNo/:totalPoints?/:payAmt?",
  name: "pointsPaySuccess",
  component: function component() {
    return import("../../../views/points-mall/pointsPaySuccess.vue");
  },
  meta: {
    title: "支付成功",
    foot: true
  }
}];